module.exports = __webpack_public_path__ + "static/img/img_1.c826b853.jpg";